// extracted by css-extract-rspack-plugin
export default {"cls1":"TransactionalPricingModal-cls1_KlV","cls2":"TransactionalPricingModal-cls2_cBg TransactionalPricingModal-cls1_KlV"};